<template>
    <card xs-tile sm-tile class="flex-grow-1" :style="isSubPage ? null : {borderTop: `2px solid ${colorStyle ?? 'transparent'}`}">

        <div v-if="thumbnail" class="w-full relative sm:none">
            <aspect-ratio-box :ratio="3/2">
                <parallax only-mobile>
                    <cdn-image :src="thumbnail"
                               :alt="job.title"
                               :size="{width: '100vw', ratio: 3/2}"
                               class="sm:rounded"/>
                </parallax>
            </aspect-ratio-box>
        </div>

        <card tile flat class="mt--8 sm:mt-0 rounded-t-lg">
            <card-text>

                <div class="mb-16">
                    <p v-if="!isSubPage" class="text-xl font-heading text-heading-color font-bold mb-2 leading-spaced">{{ job.title }}</p>
                    <h2 v-else class="text-md sm:text-lg mb-2 text-heading-color leading-spaced">{{ job.title }}</h2>

                    <nuxt-link v-if="job.event" :to="$web('events.show', job.event._key)" class="text-sub text-text-color font-regular hover:text-primary">{{ job.event.display_name }}</nuxt-link>
                    <nuxt-link v-else-if="!job.event_id" :to="$web('clubs.show', job.club._key)" class="text-sub text-text-color font-regular hover:text-primary">{{ job.club.display_name }}</nuxt-link>
                </div>
				<slot name="before_content"/>

                <section id="description" class="mb-24">
                    <position-operations-content :position="job" :group="job.event ?? job.club" hide-club/>
                </section>

                <slot name="after_content"/>

                <row>
                    <column v-if="job.event" cols="12" lg="6">
                        <p class="subheading">{{ $t('label.event') }}:</p>
                        <profile-preview :model="job.event" outlined class="mb-16"/>
                    </column>
                    <column v-if="job.club" cols="12" lg="6">
                        <p class="subheading">{{ $t('label.job_created_by') }}:</p>
                        <profile-preview :model="job.club" outlined class="mb-16"/>
                    </column>
                </row>

            </card-text>
        </card>
    </card>
</template>

<script>

import {getEventAvatarThumbnail} from "@spoferan/spoferan-ts-core";

export default {
    name: "JobPage",

    props: {
        job: {
            type: Object,
            required: true
        },

        isSubPage: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        colorStyle() {
            return this.job.event ? this.job.event.color : this.job.club.color;
        },

        thumbnail() {
            if (this.job.image) {
                return this.job.image;
            }

            return this.job.event ? getEventAvatarThumbnail(this.job.event) : null;
        },
    }
}
</script>